import React, { useState } from 'react'

import './styles.scss'
import ModalWrapper from 'components/ModalWrapper'
import ColorPickerInput from 'components/ColorPickerInput'
import Input from '../Input'
import { lang } from 'utils/helpers'

const Modal = props => {
  const { isOpen, toggle, data, onSave, isLoading, error } = props
  const [name, setName] = useState(data?.name || '')
  const [color, setColor] = useState(data?.color || '#E87721')
  const [modalError, setModalError] = useState('')

  const handleOnChangeName = value => {
    if (modalError) setModalError('')
    setName(value)
  }

  const handleSave = () => {
    if (name.length < 3) {
      setModalError(lang('dashbord_folder-name-contain-least-3-characters'))
      return
    }
    onSave({ name, color })
  }

  return (
    <ModalWrapper
      id='foldersModal'
      isOpen={isOpen}
      toggle={toggle}
      header={!data ? lang('dashboard_add-folder') : lang('dashboard_edit-folder')}
      legend={lang('dashboard_folders-config-subtitle')}
      body={
        <div className='folder-modal-body'>
          <Input
            label={lang('dashboard_folder-name')}
            placeholder={lang('dashboard_name')}
            value={name}
            onChange={handleOnChangeName}
          />
          <div className='folder-modal-body__field'>
            <label className='folder-modal-body__field-label'>
              {lang('dashboard_folder-color')}
            </label>
            <ColorPickerInput color={color} setColor={setColor} />
          </div>
        </div>
      }
      eventBtnTxt={lang('dashboard_save')}
      eventBtn={handleSave}
      cancelBtnTxt={lang('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={isLoading}
      error={error || modalError}
    />
  )
}

export default Modal
